import {
  DropdownMenuContent,
  DropdownMenuItem,
} from "@components/ui/dropdown-menu";
import { IconArrowBackUp, IconTrash } from "@tabler/icons-react";

const itemClass =
  "tw-h-8 tw-gap-2 tw-rounded tw-px-2 tw-py-1.5 tw-text-[14px] tw-text-blue data-[highlighted]:tw-bg-blue-50";

export const DeleteRestoreMenu = ({
  onRestore,
  onDelete,
}: {
  onRestore: () => void;
  onDelete: () => void;
}) => (
  <DropdownMenuContent align="center" className="tw-w-44 tw-p-1">
    <DropdownMenuItem className={itemClass} onClick={onRestore}>
      <IconArrowBackUp
        className="tw-size-4 tw-shrink-0 tw-text-blue"
        stroke={1}
      />
      Restore
    </DropdownMenuItem>
    <DropdownMenuItem className={itemClass} onClick={onDelete}>
      <IconTrash
        className="tw-size-4 tw-shrink-0 tw-text-blue"
        stroke={1}
      />
      Delete permanently
    </DropdownMenuItem>
  </DropdownMenuContent>
);
